export default "__VITE_ASSET__093e82f7__"